module.exports = __webpack_public_path__ + "img/solicitud-recibida.19d32565.svg";